import { render, staticRenderFns } from "./FormFormulary.vue?vue&type=template&id=2530e366"
import script from "./FormFormulary.vue?vue&type=script&lang=js"
export * from "./FormFormulary.vue?vue&type=script&lang=js"
import style0 from "./FormFormulary.vue?vue&type=style&index=0&id=2530e366&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports